import Home from "./components/Home";
import Patterns from "./components/patterns/Patterns";
import Tips from "./components/tips/Tips";
import Tools from "./components/tools/Tools";
import SpicedBiscuitsBlanket from "./components/patterns/SpicedBiscuitsBlanket";
import PomPomBorder from "./components/tips/PomPomBorder";
import DolciBeanie from "./components/tips/DolciBeanie";
import ColourChart from "./components/tools/ColourChart";
import ColourCombinations from "./components/tools/ColourCombinations"
import ColourSuggestor from "./components/tools/ColourSuggestor";
import CrochetAlong from "./components/CrochetAlong";

const AppRoutes = [
  {
    index: true,
    element: <Home />
    },
    {
        path: '/patterns',
        element: <Patterns />
    },
    {
        path: '/patterns/spiced-biscuits-blanket',
        element: <SpicedBiscuitsBlanket />
    },
    {
        path: '/free-patterns',
        element: <Tips />
    },
    {
        path: '/free-patterns/pom-pom-border',
        element: <PomPomBorder />
    },
    {
        path: '/free-patterns/dolci-beanie',
        element: <DolciBeanie />
    },
    {
        path: '/tools',
        element: <Tools />
    },
    {
        path: '/tools/colour-chart',
        element: <ColourChart />
    },
    {
        path: '/tools/granny-square-colour-picker',
        element: <ColourCombinations />
    },
    {
        path: '/tools/colour-suggest',
        element: <ColourSuggestor />
    },
    {
        path: '/cuddle-up-blanket-crochet-along',
        element: <CrochetAlong />
    }
];

export default AppRoutes;
